export { default as VictoryStack } from "./victory-stack";


//////////////////
// WEBPACK FOOTER
// ./~/victory-stack/es/index.js
// module id = ./node_modules/victory-stack/es/index.js
// module chunks = 1